import React from 'react'
import SubNavbar from '../components/SubNavbar'
import Navbar from '../components/Navbar'
import Single from './Single'
import Section from '../Home/Section'
import Footer from '../Home/Footer'
import { CartProvider } from 'react-use-cart'

function AllDetials() {
  return (
    <CartProvider>
        <SubNavbar/>
        <Navbar/>
        <Single/>
        <Section/>
        <Footer/>
    </CartProvider>
  )
}

export default AllDetials